import React from 'react';
import Button from '@mui/material/Button';
import SubscribeEmailModal from './SubscribeEmailModal';
import { JobTitleContext } from '@/context/create-context';
import { JobOptionType } from '@/components/job-title/search-area/JobTitleSearch';
import { trackClickEvent } from '@/utils/site-track';

const Subscribe = () => {
  const {
    jobTitle: { id, name, aliases, location },
    displayName,
  } = React.useContext(JobTitleContext);
  const [open, setOpen] = React.useState(false);
  const [jobValue, setJobValue] = React.useState<JobOptionType>({
    id: '',
    name: '',
    nameType: 'primary',
    aliasId: '',
  });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackClickEvent(e);
    setOpen(true);
  };

  React.useEffect(() => {
    if (id && displayName) {
      const filteredAlias = aliases
        .filter((alias) => alias.name === displayName)
        .pop();
      id &&
        setJobValue({
          id,
          name: displayName,
          nameType: displayName === name ? 'primary' : 'alias',
          aliasId: filteredAlias ? filteredAlias.id : '',
        });
    }
  }, [displayName, id]);

  return (
    <div className="px-4 mt-6 tablet:px-0 tablet:mt-0">
      <Button
        className="!w-full !h-[46px] !text-base !rounded-lg !bg-blue-50 !border-web-blue-500 !border-2 tablet:!w-40"
        variant="outlined"
        onClick={handleClick}
        data-ele-group="subscribe"
        data-ele-id="subscribe_job-title_top"
        data-observer-id="subscribe_job-title_top"
      >
        订阅
      </Button>
      <SubscribeEmailModal
        open={open}
        setOpen={setOpen}
        jobValue={jobValue}
        city={
          location?.id
            ? { id: location.id, name: location.name, pinyin: location.pinyin }
            : undefined
        }
      />
    </div>
  );
};

export default Subscribe;
